module.exports = __webpack_public_path__ + "static/img/img-klab-edu.c3240d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-klab-edu.svg
// module id = Vpqa
// module chunks = 0